import {
  loadMinicart,
  openMinicart
} from '../components/minicart';
import './../../styles/templates/wishlist.scss';

const P_KEYS = {
  NAME: 'dt',
  VENDOR: 'bt',
  URL: 'du',
  IMAGE: 'iu',
  PRICE: 'pr',
  COMPARE_AT_PRICE: 'op',
  VARIANT_ID: 'epi',
  VARIANT_VALUE: 'vi'
}

const CART_OPEN_BTN_SELECTOR = '.js-drawer-open-button-right';
const CART_OPEN_BTN = document.querySelector(CART_OPEN_BTN_SELECTOR);

const fillNodesWith = (nodeOrNodeList, content) => {
  if (nodeOrNodeList) {
    // Nodelist
    if (nodeOrNodeList.length) {
      const nodes = Array.from(nodeOrNodeList);

      nodes.map(node => {
        node.innerHTML = content;
      });
    } else {
      nodeOrNodeList.innerHTML = content;
    }
  }
}

const changeNodeAttribute = (nodeOrNodeList, attributeName, attributeValue) => {
  if (nodeOrNodeList) {
    // Nodelist
    if (nodeOrNodeList.length) {
      const nodes = Array.from(nodeOrNodeList);
      nodes.map(node => {
        node.setAttribute(attributeName, attributeValue);
      });
    } else {
      nodeOrNodeList.setAttribute(attributeName, attributeValue);
    }
  }
}

const addClass = (nodeOrNodeList, className) => {
  if (nodeOrNodeList) {
    // Nodelist
    if (nodeOrNodeList.length) {
      const nodes = Array.from(nodeOrNodeList);
      nodes.map(node => {
        node.classList.add(className);
      });
    } else { // Node
      nodeOrNodeList.classList.add(className);
    }
  }
}

const removeClass = (nodeOrNodeList, className) => {
  if (nodeOrNodeList) {
    // Nodelist
    if (nodeOrNodeList.length) {
      const nodes = Array.from(nodeOrNodeList);
      nodes.map(node => {
        node.classList.remove(className);
      });
    } else { // Node
      nodeOrNodeList.classList.remove(className);
    }
  }
}

const attachListener = (nodeOrNodeList, event, callback) => {
  if (nodeOrNodeList && typeof callback === 'function') {
    // Nodelist
    if (nodeOrNodeList.length) {
      const nodes = Array.from(nodeOrNodeList);
      nodes.map(node => node.addEventListener(event, callback))
    } else { // Node
      nodeOrNodeList.addEventListener(event, callback);
    }
  }
}

const addToCart = async (items, errorCallback) => {
  return await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    body: JSON.stringify(items),
    headers: {
      "Content-Type": "application/json"
    }
  })
    .then(async response => {
      let errorMessage = '';
      if (!response.ok) {
        if (typeof errorCallback === 'function') {
          await response.json().then(data => {
            errorMessage = data.description;
            errorCallback(data.description)
          });
        }

        throw new Error(`Network response was not ok: ${errorMessage || response.statusText}`);
      }
      await loadMinicart();
      await openMinicart();
      return response.json();
    })
    .then(data => {
      return data;
    })
    .catch(error => {
      // Handle errors during the fetch
      console.error('Error during adding to cart:', error);
    });
}

const triggerEvent = (el, evName) => {
  const event = new CustomEvent(evName);
  el.dispatchEvent(event);
}

(function (window, $) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  const wishlistRender = function (products) {
    var template = document.querySelector('[data-wishlist-template]');
    var empty_template = document.querySelector('[data-wishlist-empty]');
    var wishlistContainer = document.getElementById('wishlist-content');

    var startLoading = function (context) {
      if (context) {
        context.classList.add('loading');
      } else {
        wishlistContainer.classList.add('loading');
      }
    }

    var stopLoading = function (context) {
      if (context) {
        context.classList.remove('loading');
      } else {
        wishlistContainer.classList.remove('loading');
      }
    }

    if (!products || products.length < 1) {
      empty_template.style.display = 'block';
      return;
    }

    products.forEach(async function (p) {
      var row = template.cloneNode(true);
      const CURRENCY = _swat.currency;
      let suffix = '?view=ajax';

      if (p[P_KEYS.URL].includes('?')) {
        suffix = '&view=ajax';
      }

      row.classList.remove('hidden');
      fillNodesWith(row.querySelectorAll('[data-name]'), p[P_KEYS.NAME]);

      // Filling vendor info

      const vendorTemplateSlots = row.querySelectorAll('[data-vendor-wrapper]');
      if (p[P_KEYS.VENDOR] && vendorTemplateSlots && vendorTemplateSlots.length) {
        fillNodesWith(row.querySelectorAll('[data-vendor-wrapper]'), p[P_KEYS.VENDOR]);
      } else {
        if (vendorTemplateSlots && vendorTemplateSlots.length) {
          addClass(vendorTemplateSlots, 'visually-hidden');
        }
      }

      // Filling variant info

      const variantTemplateSlots = row.querySelectorAll('[data-variant-wrapper]');
      if (p[P_KEYS.VARIANT_VALUE] && variantTemplateSlots && variantTemplateSlots.length) {
        fillNodesWith(row.querySelectorAll('[data-variant]'), p[P_KEYS.VARIANT_VALUE]);
      } else {
        if (variantTemplateSlots && variantTemplateSlots.length) {
          addClass(variantTemplateSlots, 'visually-hidden');
        }
      }

      changeNodeAttribute(row.querySelectorAll('[data-url]'), 'href', p[P_KEYS.URL]);
      changeNodeAttribute(row.querySelectorAll('[data-image]'), 'src', p[P_KEYS.IMAGE]);
      fillNodesWith(row.querySelectorAll('[data-price]'), p[P_KEYS.PRICE] + CURRENCY);
      changeNodeAttribute(row.querySelectorAll('[data-variant-id]'), 'data-variant-id', p[P_KEYS.VARIANT_ID]);

      if (p[P_KEYS.COMPARE_AT_PRICE] && p[P_KEYS.COMPARE_AT_PRICE] > p[P_KEYS.PRICE]) {
        var percentage = Math.round((p[P_KEYS.PRICE] * 100 / p.op), 2);
        fillNodesWith(row.querySelector('[data-percentage-value]'), percentage);
        removeClass(row.querySelector('[data-percentage-wrapper]'), 'hidden')
        addClass(row.querySelector('[data-price-container]'), 'strike-price')
        fillNodesWith(row.querySelector('[data-original-price]'), p[P_KEYS.COMPARE_AT_PRICE] + CURRENCY);
      }
      attachListener(row.querySelectorAll('[data-remove]'), 'click', function (e) {
        e.preventDefault();
        // Start Loader
        startLoading(row);

        _swat.removeFromWishList(p, function callback() {
          row.remove();
          window.loadWishlistBubble(0);
          // Stop Loader
          stopLoading(row);
        });
      });

      attachListener(row.querySelectorAll('[data-add-to-cart]'), 'click', async function (e) {
        e.preventDefault();
        // Start Loader
        startLoading(row);

        const vId = e.target.getAttribute('data-variant-id');
        if (vId) {

          const cartData = await addToCart({
            items: [{
              id: vId,
              quantity: 1
            }]
          },
            function (errorMessage) {
              const messageContainer = document.createElement("small");
              messageContainer.classList.add('wishlist__error-message');
              messageContainer.innerText = errorMessage;
              row.querySelector('[data-add-to-cart]').after(messageContainer);
            });

          window.loadWishlistBubble(0);
        }
        // Open Cart
        if (CART_OPEN_BTN) triggerEvent(CART_OPEN_BTN);

        // Stop Loader
        stopLoading(row);
      });

      await fetch(p[P_KEYS.URL] + suffix)
        .then(async (res) => res.text())
        .then(async (data) => {
          const PDPhtml = new DOMParser().parseFromString(data, 'text/html');
          if (!PDPhtml) return;

          const dataNode = PDPhtml.getElementById('json-variants-qty');

          if (!dataNode) return;

          const variantsData = JSON.parse(dataNode.innerHTML);
          if (!variantsData.variants) return;
          const currentVariant = variantsData.variants.find(variant => variant.id === p[P_KEYS.VARIANT_ID]);

          if (currentVariant.inventory_policy === 'continue' || currentVariant.inventory_quantity > 0) {
            const addToCartButtons = row.querySelectorAll('[data-add-to-cart]');
            if (addToCartButtons && addToCartButtons.length) {
              Array.from(addToCartButtons).map(atcb => {
                atcb.removeAttribute('disabled');
              });
            }
          }
        });

      wishlistContainer.append(row);
    });
  }

  window.SwymCallbacks.push(function () {
    _swat.fetchWrtEventTypeET(function (products) {
      wishlistRender(products);
    }, _swat.EventTypes.addToWishlist);
  });
})(window, jQuery);
